import React from "react";

const AppDownloadSection = () => {
  return (
    <section id="download" className="py-24 relative overflow-hidden" style={{ background: "#0a1628" }}>
      {/* Background */}
      <div
        className="absolute inset-0 opacity-[0.1]"
        style={{ background: "radial-gradient(ellipse at 50% 100%, #ffd700 0%, transparent 60%)" }}
      />
      <div
        className="absolute top-0 left-0 w-full h-px opacity-20"
        style={{ background: "linear-gradient(90deg, transparent, #ffd700, transparent)" }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left content */}
          <div>
            <div
              className="inline-flex items-center gap-2 rounded-full px-4 py-2 mb-6 border"
              style={{ background: "rgba(255,215,0,0.08)", borderColor: "rgba(255,215,0,0.2)" }}
            >
              <span className="text-[#ffd700] text-sm font-semibold">📲 Get the App</span>
            </div>
            <h2
              className="text-4xl lg:text-6xl font-black text-white mb-6 leading-tight"
              style={{ fontFamily: "'DM Sans', sans-serif" }}
            >
              Your City.
              <br />
              <span className="text-[#ffd700]">Your Pace.</span>
              <br />
              Your App.
            </h2>
            <p className="text-white/55 text-lg leading-relaxed mb-10 max-w-md">
              Download OnTheGo and join 50,000+ riders and drivers across Africa. Available on iOS and Android — free forever.
            </p>

            {/* App store buttons — "Coming Soon" style */}
            <div className="flex flex-wrap gap-4 mb-10">
              {/* Google Play */}
              <a
                href="https://play.google.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 px-6 py-4 rounded-2xl border transition-all duration-300 hover:scale-105 group relative"
                style={{
                  background: "rgba(255,255,255,0.05)",
                  borderColor: "rgba(255,255,255,0.15)",
                  opacity: 0.75,
                  cursor: "default",
                  pointerEvents: "none",
                }}
              >
                <svg className="w-8 h-8" viewBox="0 0 24 24" fill="currentColor" style={{ color: "#34d399" }}>
                  <path d="M3.18 23.76c.3.17.64.24.99.2l12.6-12.6L13.2 7.8 3.18 23.76zm16.44-10.8L16.8 11.4l-3.6 3.6 3.6 3.6 2.82-1.56c.8-.44.8-1.64 0-2.08zM3.6.24C3.24.2 2.9.27 2.6.44L14.4 12.24 17.96 8.7 3.6.24zM2.4 1.2c-.24.3-.4.68-.4 1.12v19.36c0 .44.16.82.4 1.12l.12.12L14.16 11.16v-.32L2.52 1.08l-.12.12z"/>
                </svg>
                <div>
                  <div className="text-white/40 text-xs">Coming Soon on</div>
                  <div className="text-white font-bold text-lg leading-tight">Google Play</div>
                </div>
                <span
                  className="absolute -top-2 -right-2 text-[10px] font-bold px-2 py-0.5 rounded-full"
                  style={{ background: "#ffd700", color: "#0a1628" }}
                >
                  Soon
                </span>
              </a>

              {/* App Store */}
              <a
                href="https://apps.apple.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 px-6 py-4 rounded-2xl border transition-all duration-300 hover:scale-105 relative"
                style={{
                  background: "rgba(255,255,255,0.05)",
                  borderColor: "rgba(255,255,255,0.15)",
                  opacity: 0.75,
                  cursor: "default",
                  pointerEvents: "none",
                }}
              >
                <svg className="w-8 h-8" viewBox="0 0 24 24" fill="currentColor" style={{ color: "#60a5fa" }}>
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                </svg>
                <div>
                  <div className="text-white/40 text-xs">Coming Soon on the</div>
                  <div className="text-white font-bold text-lg leading-tight">App Store</div>
                </div>
                <span
                  className="absolute -top-2 -right-2 text-[10px] font-bold px-2 py-0.5 rounded-full"
                  style={{ background: "#ffd700", color: "#0a1628" }}
                >
                  Soon
                </span>
              </a>
            </div>

            {/* App features */}
            <div className="grid grid-cols-2 gap-3">
              {[
                { icon: "🌐", text: "Works offline" },
                { icon: "🌍", text: "Multi-language" },
                { icon: "🔒", text: "Secure & encrypted" },
                { icon: "⚡", text: "Instant booking" },
              ]?.map((item) => (
                <div key={item?.text} className="flex items-center gap-3 text-white/55 text-sm">
                  <span className="text-lg">{item?.icon}</span>
                  <span>{item?.text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right: QR codes only (no duplicate phone mockup) */}
          <div className="flex flex-col items-center justify-center gap-8">
            <div className="text-center mb-2">
              <div className="text-white/40 text-sm mb-1">Scan to download</div>
              <div className="text-white font-bold text-lg">Available soon on all platforms</div>
            </div>

            {/* QR code placeholders */}
            <div className="grid grid-cols-2 gap-6 w-full max-w-sm">
              {[
                { label: "Android", sublabel: "Google Play", color: "#34d399" },
                { label: "iOS", sublabel: "App Store", color: "#60a5fa" },
              ]?.map((qr) => (
                <div
                  key={qr?.label}
                  className="p-6 rounded-3xl border text-center"
                  style={{ background: "rgba(255,255,255,0.03)", borderColor: "rgba(255,255,255,0.08)" }}
                >
                  <div
                    className="w-20 h-20 mx-auto mb-4 rounded-2xl flex items-center justify-center"
                    style={{ background: `${qr?.color}12`, border: `1.5px solid ${qr?.color}25` }}
                  >
                    <div
                      className="w-14 h-14 rounded-xl"
                      style={{
                        backgroundImage: `repeating-linear-gradient(0deg, ${qr?.color}50 0px, ${qr?.color}50 2px, transparent 2px, transparent 5px), repeating-linear-gradient(90deg, ${qr?.color}50 0px, ${qr?.color}50 2px, transparent 2px, transparent 5px)`,
                      }}
                    />
                  </div>
                  <div className="text-white font-bold text-base mb-1">{qr?.label}</div>
                  <div className="text-white/35 text-xs">{qr?.sublabel}</div>
                  <div
                    className="mt-3 text-xs font-semibold px-3 py-1 rounded-full inline-block"
                    style={{ background: `${qr?.color}15`, color: qr?.color }}
                  >
                    Coming Soon
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppDownloadSection;
